module.exports = __webpack_public_path__ + "img/五鮮級平價鍋物.a1895764.svg";